import { createListenerMiddleware } from '@reduxjs/toolkit';
import { createListenerEffect } from '@socialive/common';
import baseEffect from './effect';

export const effect = createListenerEffect('features/updateSplitConstOnUpdate<Listener>', baseEffect);

const actionTypes = new Set(['ADD_TREATMENTS', 'SPLIT_READY_WITH_EVALUATIONS']);

export const predicate = (action, state) => actionTypes.has(action.type);

const { startListening, middleware } = createListenerMiddleware();

startListening({
  predicate,
  effect,
});

export default middleware;
